import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const DemoBrandBeforeStartView: React.FC = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/demobrand/scan");
  };

  const handleBack = () => {
    navigate("/demobrand/takeback");
  };

  const steps = [
    {
      number: 1,
      title: "Place your item",
      description:
        "Position your item on the scanning pad so it is clearly visible.",
    },
    {
      number: 2,
      title: "AI assessment",
      description:
        "Our AI will identify and assess the condition of your item.",
    },
    {
      number: 3,
      title: "Accept offer",
      description:
        "Review your offer and accept to receive your store credit instantly.",
    },
  ];

  return (
    <div className="min-h-screen bg-[#0A1628] flex flex-col">
      {/* Header */}
      <header className="py-6 px-8 flex items-center justify-between">
        <button
          onClick={handleBack}
          className="text-white/60 hover:text-white transition-colors flex items-center gap-2"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Back
        </button>
        <div className="flex items-center gap-3">
          <span className="text-white font-semibold text-xl">Demo Brand</span>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-8 pb-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold text-white mb-4">
            Before We Start
          </h1>
          <p className="text-xl text-white/60 max-w-lg mx-auto">
            Here's how the trade-in process works
          </p>
        </motion.div>

        {/* Steps */}
        <div className="flex gap-8 max-w-4xl w-full mb-12">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.2 + index * 0.1 }}
              className="flex-1 bg-white/5 rounded-2xl p-6 border border-white/10 relative"
            >
              <div className="absolute -top-4 left-6 w-8 h-8 bg-[#0066CC] rounded-full flex items-center justify-center text-white font-bold">
                {step.number}
              </div>
              <h3 className="text-white font-bold text-lg mb-2 mt-2">
                {step.title}
              </h3>
              <p className="text-white/60 text-sm">{step.description}</p>
            </motion.div>
          ))}
        </div>

        {/* CTA Button */}
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.5 }}
          onClick={handleContinue}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="bg-[#0066CC] text-white px-12 py-4 rounded-lg font-bold tracking-wider text-lg shadow-xl hover:bg-[#0055AA] transition-colors"
        >
          Continue
        </motion.button>
      </main>

      {/* Footer */}
      <footer className="py-4 px-8 text-center text-white/40 text-sm border-t border-white/10">
        Powered by Pentatonic AI
      </footer>
    </div>
  );
};

export default DemoBrandBeforeStartView;
